/**
 * ZISANO POWER — lightweight interaction layer
 * 1) header shrink/shadow on scroll
 * 2) ripple effect on .button click
 * 3) subtle magnetic pull on primary buttons (desktop, pointer:fine only)
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1) Header scroll state ---- */
  var headerSection = document.querySelector('.shopify-section-header');
  if (headerSection) {
    var lastY = window.scrollY;
    var toggleHeader = function () {
      var y = window.scrollY;
      if (y > 40) {
        headerSection.classList.add('zp-header-scrolled');
      } else {
        headerSection.classList.remove('zp-header-scrolled');
      }
      lastY = y;
    };
    toggleHeader();
    window.addEventListener('scroll', toggleHeader, { passive: true });
  }

  /* ---- 2) Ripple effect on buttons ---- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.button') : null;
    if (!button || reduceMotion) return;

    var rect = button.getBoundingClientRect();
    var ripple = document.createElement('span');
    var size = Math.max(rect.width, rect.height) * 1.4;

    ripple.style.position = 'absolute';
    ripple.style.width = size + 'px';
    ripple.style.height = size + 'px';
    ripple.style.left = (event.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (event.clientY - rect.top - size / 2) + 'px';
    ripple.style.borderRadius = '50%';
    ripple.style.background = 'rgba(255,255,255,0.45)';
    ripple.style.transform = 'scale(0)';
    ripple.style.opacity = '1';
    ripple.style.pointerEvents = 'none';
    ripple.style.transition = 'transform 550ms ease, opacity 550ms ease';

    var priorPosition = getComputedStyle(button).position;
    if (priorPosition === 'static') button.style.position = 'relative';
    button.appendChild(ripple);

    requestAnimationFrame(function () {
      ripple.style.transform = 'scale(1)';
      ripple.style.opacity = '0';
    });

    window.setTimeout(function () {
      ripple.remove();
    }, 600);
  });

  /* ---- 3) Magnetic pull on primary buttons (desktop only) ---- */
  if (!reduceMotion && window.matchMedia('(pointer: fine)').matches) {
    var magnets = document.querySelectorAll('.button--primary');
    magnets.forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + x * 0.08 + 'px,' + (y * 0.16 - 2) + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }
})();
